export enum TrackingProvider {
    NONE = 'NONE',
    EFCOLIA = 'EFCOLIA',
    GPSTRACKING= 'GPSTRACKING',
}
